<form [formGroup]="form">
  <div class="section">
    <div class="section-header">
      <span class="section-title">Dados básicos</span>
    </div>
    <mat-divider></mat-divider>
    <br />
    <div class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="name" required>
        @if (form.get('name')?.hasError('required')) {
          <mat-error>Nome é obrigatório</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email">
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>CNPJ</mat-label>
        <input
          matInput
          formControlName="cnpj"
          mask="AA.AAA.AAA/AAAA-AA"
          [inputTransformFn]="uppercaseInput"
          [dropSpecialCharacters]="true">
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>Telefones</mat-label>
        <mat-chip-grid #chipGrid>
          @for (phone of phoneNumbers.controls; track phone; let i = $index) {
            <mat-chip-row [removable]="true" (removed)="removePhone(i)">
              {{phone.value}}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
          }
          <input placeholder="Novo telefone..."
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addPhone($event)">
        </mat-chip-grid>
      </mat-form-field>
    </div>
  </div>

  <div class="section">
    <div class="section-header">
      <span class="section-title">Endereço</span>
    </div>
    <mat-divider></mat-divider>
    <br />

    <div formGroupName="address">
      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>Rua</mat-label>
          <input matInput formControlName="street" required>
          @if (form.get('address.street')?.hasError('required')) {
            <mat-error>Rua é obrigatória</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>Número</mat-label>
          <input matInput formControlName="number" required>
          @if (form.get('address.number')?.hasError('required')) {
            <mat-error>Número é obrigatório</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>Complemento</mat-label>
          <input matInput formControlName="complement">
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>Bairro</mat-label>
          <input matInput formControlName="neighborhood">
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>Cidade</mat-label>
          <input matInput formControlName="city" required>
          @if (form.get('address.city')?.hasError('required')) {
            <mat-error>Cidade é obrigatória</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>Estado</mat-label>
          <input matInput formControlName="state" required>
          @if (form.get('address.state')?.hasError('required')) {
            <mat-error>Estado é obrigatório</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>País</mat-label>
          <input matInput formControlName="country" required>
          @if (form.get('address.country')?.hasError('required')) {
            <mat-error>País é obrigatório</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>CEP</mat-label>
          <input
            matInput
            formControlName="zipCode"
            mask="00000-000"
            [dropSpecialCharacters]="true"
            inputmode="numeric">
        </mat-form-field>
      </div>
    </div>
  </div>

  @if (showTermsAcceptance) {
    <div class="terms-acceptance">
      <mat-checkbox formControlName="acceptedTermsOfUse">
        Declaro que li e aceito os
        <a href="assets/legal/terms-of-use.html" target="_blank" rel="noopener noreferrer">termos de uso</a>
      </mat-checkbox>
      <mat-checkbox formControlName="acceptedPrivacyPolicy">
        Declaro que li e aceito a
        <a href="assets/legal/privacy-policy.html" target="_blank" rel="noopener noreferrer">política de privacidade</a>
      </mat-checkbox>
    </div>
  }
</form>


